import React from 'react';
import cx from 'clsx';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core';
import { format } from 'date-fns';
import { ORDER_DATE_FORMAT } from '../../../utils/constants';
import { MastercodeExpirationDate } from '..';

export type Props = {
  className?: string;
  expirationDates: MastercodeExpirationDate[];
};

const MastercodeExpirationList = ({ expirationDates, className }: Props) => {
  const classes = useStyles();
  const { t } = useTranslation('Order');

  return (
    <ul className={cx(classes.root, className)}>
      {expirationDates.map(({ code, date }) => (
        <li key={code}>
          {t('mastercode', { code })}
          <br />
          {t('expireDate', { date: format(date, ORDER_DATE_FORMAT) })}
        </li>
      ))}
    </ul>
  );
};

export default MastercodeExpirationList;

const useStyles = makeStyles(() => ({
  root: {
    margin: 0,
    paddingInlineStart: '15px',
    '& > li': { marginTop: 10 }
  }
}));
